import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getTenantMe } from './api';
import { tenantQueryKeys } from './query-keys';
import { TenantResponse } from './models';
import { useTenant } from '@/lib/auth/tenant-context';

export const useTenantMe = (
  options?: Omit<UseQueryOptions<TenantResponse>, 'queryKey' | 'queryFn'>
) => {
  const { selectedTenant } = useTenant();

  return useQuery({
    queryKey: tenantQueryKeys.tenantMe(selectedTenant?.id),
    queryFn: () => getTenantMe(selectedTenant!.id),
    enabled: !!selectedTenant?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...options,
  });
};
